import React from 'react';
import { Theme } from '@/utils/constants';
import { IPriceListItem } from './components/FileItem';
import FileList from './components/FileList';
import { DownloadResourceProviders } from './hooks/useDownloadPriceListHandler';
import useStyles from './PriceList.styles';
import { PortalTitlePage } from '../shared/portal';
import { RichText } from '../shared';

interface IPriceListProps {
  title: string;
  description: string;
  items: IPriceListItem[];
  theme?: any;
  priceListLabels?: any;
  downloadProvider?: DownloadResourceProviders;
}

const PriceList = ({
  title,
  description,
  items = [],
  theme = Theme.dark,
  contentButtons,
  priceListLabels,
  downloadProvider,
}: Br.PropsWithContentButtons<IPriceListProps>) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {contentButtons?.content}
      <div className={classes.textWrapper}>
        <div className={classes.titleWrapper}>
          <PortalTitlePage>{title}</PortalTitlePage>
        </div>
        <RichText className={classes.description} theme={theme} content={description} />
      </div>
      <FileList
        fileItems={items}
        priceListLabels={priceListLabels}
        downloadProvider={downloadProvider}
      />
    </div>
  );
};

export default PriceList;
